"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selector = selector;
exports.actor = actor;
exports.reducer = reducer;

var _types = require("../types");

var _reducers;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var populate = function populate(state, action) {
  return action.payload.reduce(function (res, record) {
    res.allIds.push(record.id);
    res.byId[record.id] = record;
    return res;
  }, {
    allIds: [],
    byId: {}
  });
};

var insert = function insert(state, action) {
  var record = action.payload;

  if (!state) {
    return {
      allIds: [record.id],
      byId: _defineProperty({}, record.id, record)
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    if (state.byId[record.id]) {
      console.warn("Insert record with id ".concat(record.id, " when it already exists on schema ").concat(action.schema));
    }
  }

  return {
    allIds: state.allIds.concat(record.id),
    byId: _objectSpread({}, state.byId, _defineProperty({}, record.id, record))
  };
};

var update = function update(state, action) {
  var record = action.payload;

  if (!state || !state.byId[record.id]) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn("Trying to update schema ".concat(action.schema, " with record id ").concat(record.id, " which doesn't exist"));
    }

    return state;
  }

  return {
    allIds: state.allIds,
    byId: _objectSpread({}, state.byId, _defineProperty({}, record.id, _objectSpread({}, state.byId[record.id], record)))
  };
};

var remove = function remove(state, action) {
  var id = action.payload;

  if (!state || !state.byId[id]) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn("Trying to delete a record from schema ".concat(action.schema, " with id ").concat(id, " which doesn't exist"));
      return state;
    }
  }

  var clone = Object.assign({}, state.byId);
  delete clone[id];
  return {
    allIds: state.allIds.filter(function (rid) {
      return rid !== id;
    }),
    byId: clone
  };
};

var replace = function replace(state, action) {
  var record = action.payload;

  if (!state || !state.byId[record.id]) {
    return insert(state, action);
  }

  return {
    allIds: state.allIds,
    byId: _objectSpread({}, state.byId, _defineProperty({}, record.id, record))
  };
};

var upsert = function upsert(state, action) {
  var record = action.payload;

  if (!state || !state.byId[record.id]) {
    return insert(state, action);
  }

  return update(state, action);
};

var reducers = (_reducers = {}, _defineProperty(_reducers, _types.POPULATE, populate), _defineProperty(_reducers, _types.INSERT, insert), _defineProperty(_reducers, _types.UPDATE, update), _defineProperty(_reducers, _types.DELETE, remove), _defineProperty(_reducers, _types.REPLACE, replace), _defineProperty(_reducers, _types.UPSERT, upsert), _reducers);

function selector(getState) {
  return {
    allIds: function allIds() {
      var state = getState();
      return state && state.allIds;
    },
    get: function get(id) {
      var state = getState();
      return state && state.byId[id];
    },
    length: function length() {
      var state = getState();
      return state && state.allIds.length;
    }
  };
}

function actor(schema, dispatch) {
  return {
    populate: function populate(records) {
      return dispatch({
        type: _types.POPULATE,
        schema: schema,
        payload: records
      });
    },
    insert: function insert(record) {
      return dispatch({
        type: _types.INSERT,
        schema: schema,
        payload: record
      });
    },
    update: function update(record) {
      return dispatch({
        type: _types.UPDATE,
        schema: schema,
        payload: record
      });
    },
    "delete": function _delete(id) {
      return dispatch({
        type: _types.DELETE,
        schema: schema,
        payload: id
      });
    },
    replace: function replace(record) {
      return dispatch({
        type: _types.REPLACE,
        schema: schema,
        payload: record
      });
    },
    upsert: function upsert(record) {
      return dispatch({
        type: _types.UPSERT,
        schema: schema,
        payload: record
      });
    }
  };
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var actionReducer = reducers[action.type];

  if (!actionReducer) {
    console.warn("Unknown action ".concat(action.type, " trying to execute on schema ").concat(action.schema));
    return state;
  }

  return actionReducer(state, action);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sharingapples/redux/dist/schema/normalized/index.js
// module id = 367
// module chunks = 2